module.exports = __webpack_public_path__ + "static/media/top_cheese_background.0c08e158.svg";